import { render, staticRenderFns } from "./MainNavigationListButton.vue?vue&type=template&id=51ba7df0"
import script from "./MainNavigationListButton.vue?vue&type=script&lang=js"
export * from "./MainNavigationListButton.vue?vue&type=script&lang=js"
import style0 from "./MainNavigationListButton.vue?vue&type=style&index=0&id=51ba7df0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports